import { create } from 'zustand';
import commonMiddlewares from './middlewares';

import getCustomFields from '../api/getCustomFields';
import getCustomPicklistBookmarks from '../utils/getCustomPicklistBookmarks';
import getCustomFieldBookmarks from '../utils/getCustomFieldBookmarks';

export const useBookmarksStore = create(
	commonMiddlewares(set => ({
		customPickLists: [],
		customFields: [],
		bookmarkLoading: false,
		bookmarkLoaded: false,

		setCustomPickLists: pickListsUpdater =>
			set(
				state => ({
					customPickLists:
						typeof pickListsUpdater === 'function'
							? pickListsUpdater(state.customPickLists)
							: pickListsUpdater,
				}),
				false,
				'bookmarks/setCustomPicklists'
			),

		setCustomFields: fieldsUpdater =>
			set(
				state => ({
					customFields:
						typeof fieldsUpdater === 'function' ? fieldsUpdater(state.customFields) : fieldsUpdater,
				}),
				false,
				'bookmarks/setCustomFields'
			),
		fetchBookmarks: async ({ __config, internalManagingOrganizationID }) => {
			try {
				const BOOKMARKS_TYPE = ['picklist', 'field'];
				const bookmarkLoader = async type => {
					// To initialize picklist Item to  Bookmarks/reset default value on apply template
					const data = await getCustomFields({
						__config,
						criteria: `?type=${type}&InternalOrganizationID=${internalManagingOrganizationID}`,
					});
					return data;
				};

				set(() => ({ bookmarkLoading: true }), false, 'bookmarks/fetchBookmarks');
				const [pickLists, fields] = await Promise.all(BOOKMARKS_TYPE.map(type => bookmarkLoader(type)));
				const mapPicklists = getCustomPicklistBookmarks(pickLists);
				const mapFields = getCustomFieldBookmarks(fields);
				set(
					() => ({
						customPickLists: mapPicklists,
						customFields: mapFields,
						bookmarkLoading: false,
						bookmarkLoaded: true,
					}),
					false,
					'bookmarks/fetchBookmarks'
				);
			} catch (err) {
				console.error(err);
				throw err;
			}
		},

		resetBookmarksStore: () =>
			set({
				customPickLists: [],
				customFields: [],
				bookmarkLoading: false,
				bookmarkLoaded: false,
			}),
	}))
);
